module.exports = __webpack_public_path__ + "img/feature-icon.d1abf511.svg";